import {
  createContext,
  useState,
  ReactNode,
} from "react";

import {showToast} from "./showToast";
import { Notification } from "./NotificationTypes";

interface ContextType {
  notifications: Notification[];
  addNotification: (
    notification: Omit<
      Notification,
      "id" | "read" | "createdAt"
    >
  ) => void;
  markAsRead: (id: string) => void;
}

export const NotificationContext =
  createContext<ContextType>(null!);

export const NotificationProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [notifications, setNotifications] =
    useState<Notification[]>([]);

  const addNotification = (
    item: Omit<
      Notification,
      "id" | "read" | "createdAt"
    >
  ) => {
    const notification = {
      ...item,
      id: crypto.randomUUID(),
      read: false,
      createdAt: new Date().toISOString(),
    };

    setNotifications((prev) => [
      notification,
      ...prev,
    ]);

    // عرض Toast تلقائياً
    switch (item.type) {
      case "success":
        showToast("success",item.title,item.message) 
        break;

      case "error":
         showToast("error",item.title,item.message)
        break;

      case "warning":
        showToast("warning",item.title,item.message)
        break;

      case "info":
         showToast("info",item.title,item.message)
        break;

      default:
        showToast("error",item.title,item.message)
    }
  };

  const markAsRead = (id: string) => {
    setNotifications((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, read: true }
          : item
      )
    );
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        addNotification,
        markAsRead,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};